import React from 'react';
import PropTypes from 'prop-types';

import { Box, Card, CardContent } from '@mui/material';
import Typography from '@mui/material/Typography';

import { PRIMARY_FONT } from '../../../../../theme/fontConstants';

const styles = {
  cardStyle: {
    width: '340px',
    borderRadius: '16px',
    p: 2,
  },
  headerStyle: {
    fontSize: '20px',
    fontFamily: PRIMARY_FONT[700],
    my: 1,
  },
};

const SectionCard = ({ header, headerTestId, children }) => (
  <Box>
    {header && (
      <Typography sx={styles.headerStyle} data-testid={headerTestId}>
        {header}
      </Typography>
    )}
    <Card variant="outlined" sx={styles.cardStyle}>
      <CardContent sx={{ p: 0, '&:last-child': { pb: 0 } }}>{children}</CardContent>
    </Card>
  </Box>
);

SectionCard.propTypes = {
  header: PropTypes.string,
  headerTestId: PropTypes.string,
  children: PropTypes.node.isRequired,
};

export default SectionCard;
